import { Button, Col, Divider, Drawer, Row, Tooltip } from "antd";
import React, { useContext, useState } from "react";
import { UserInfo } from "../../../context";
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
import EditCredentials from "./EditCredentials";
import EditContact from "./EditContact";

const DescriptionItem = ({ title, content }) => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">{title}:</p>
    {content}
  </div>
);

const PasswordItem = () => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">Password:</p>
    &#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;
  </div>
);

const AccountDetails = ({ open, close }) => {
  const { userData } = useContext(UserInfo);
  const [editContact, setEditContact] = useState(false);
  const [editCredentials, setEditCredentials] = useState(false);

  return (
    <Drawer onClose={close} open={open} placement="right" closable={false}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <div style={{ flexGrow: 1 }}></div>
        <div>
          <Tooltip title="Close">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                close();
              }}
              icon={<CloseOutlined />}
            />
          </Tooltip>
        </div>
      </div>
      {userData.ready && (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Contacts</p>
            </div>
            <div>
              <Tooltip title="Edit Contacts">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditContact(true);
                  }}
                  icon={<EditOutlined />}
                  disabled
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Email"
                content={
                  userData.data.email !== null ? userData.data.email : ""
                }
              />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Credentials</p>
            </div>
            <div>
              <Tooltip title="Edit Credentials">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditCredentials(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Username"
                content={userData.data.username}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <PasswordItem />
            </Col>
          </Row>
        </>
      )}

      {editContact && (
        <EditContact open={editContact} close={() => setEditContact(false)} />
      )}

      {editCredentials && (
        <EditCredentials
          open={editCredentials}
          close={() => setEditCredentials(false)}
        />
      )}
    </Drawer>
  );
};

export default AccountDetails;
